export default __webpack_public_path__ + "static/media/Cover.7d06f77a.jpg";